module.exports = __webpack_public_path__ + "img/chevron-down-white.5add7348.svg";